// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"d053ff59","825":"9634b7cd"}[chunkId] + ".chunk.js";
};